var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.479,
    height: 24.003,
    viewBox: "0 0 24.479 24.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(-532.229 -4139.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M97.305,11.48l-16.041.038a2.686,2.686,0,0,0-2.665,2.69V29.094H76.225a.625.625,0,0,0-.624.626v1.558a2.686,2.686,0,0,0,2.678,2.687H90.453a.626.626,0,0,0,0-1.252H78.279a1.433,1.433,0,0,1-1.429-1.435v-.932h13.6a.626.626,0,0,0,0-1.252H79.847V14.207a1.436,1.436,0,0,1,1.429-1.435L95,12.74a2.76,2.76,0,0,0-.457,1.525v3.394a.624.624,0,1,0,1.249,0v-3.4a1.52,1.52,0,1,1,3.04,0V15.1H97.468a.626.626,0,0,0,0,1.252h2a.625.625,0,0,0,.614-.626V14.262a2.781,2.781,0,0,0-2.775-2.782Z",
    transform: "translate(456.628 4127.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M450.865,431.2a.625.625,0,0,0-.625.625v3.989a.625.625,0,0,0,1,.5l1.338-1.03,1.338,1.03h0a.625.625,0,0,0,1-.5V431.86a.625.625,0,1,0-1.25,0v2.681l-.713-.55a.625.625,0,0,0-.763,0l-.713.55v-2.716a.625.625,0,0,0-.613-.625Z",
    transform: "translate(98.713 3726.865)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(538.749 4146.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M389.155,199.167a.793.793,0,0,1,.473.553,2.026,2.026,0,0,0,1.108,1.4,2.144,2.144,0,0,0,1.891,0,.913.913,0,0,1,.8,0,2.146,2.146,0,0,0,1.891,0,2.024,2.024,0,0,0,1.108-1.4.792.792,0,0,1,.473-.553,2.021,2.021,0,0,0,1.2-1.421,1.958,1.958,0,0,0-.453-1.751.728.728,0,0,1-.163-.66,1.959,1.959,0,0,0-.36-1.731,2.114,2.114,0,0,0-1.721-.8.855.855,0,0,1-.705-.318,2.143,2.143,0,0,0-3.324,0,.878.878,0,0,1-.705.318,2.108,2.108,0,0,0-1.721.8,1.958,1.958,0,0,0-.36,1.731.728.728,0,0,1-.163.67,1.961,1.961,0,0,0-.453,1.751,2.024,2.024,0,0,0,1.193,1.411Z",
    transform: "translate(-380.492 -190.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M229.743,176.015a.625.625,0,0,0-.625-.625h-6.5a.625.625,0,1,0,0,1.25h6.5a.625.625,0,0,0,.625-.625Z",
    transform: "translate(-221.98 -175.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M227.545,246.685a.625.625,0,0,0-.625-.625h-4.534a.625.625,0,1,0,0,1.25h4.534a.625.625,0,0,0,.625-.625Z",
    transform: "translate(-221.76 -242.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M226.766,316.68h-4.039a.625.625,0,1,0,0,1.25h4.039a.625.625,0,0,0,0-1.25Z",
    transform: "translate(-222.087 -310.37)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M222.385,106.03h8.888a.625.625,0,1,0,0-1.25h-8.888a.625.625,0,1,0,0,1.25Z",
    transform: "translate(316.989 4038.674)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateIcon);
export default __webpack_public_path__ + "static/media/certificateIcon.766333f2179edeac59d816f423109e7c.svg";
export { ForwardRef as ReactComponent };